module.exports = "/images/mia.jpg?6c689f7a89d639a63e6958b689ac386b";